import {
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ApiUser } from "../../models";
import * as userActions from "../../actions/userActions";
import { withApplicationInsights } from "../../components/telemetry";
import { useNavigate } from "react-router-dom";
import CrudGrid from "../../components/crudGrid";
import CustomToolbar from "../../components/customToolbar";
import { commentsColumn, createdAtColumn as createdDateColumn, createdByColumn, emailColumn, emptyUserRepresentation, firstNameColumn, lastNameColumn, organizationColumn, roleColumn } from "../../models/userRepresentation";
import { Box, CssBaseline } from "@mui/material";

const UsersPage = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [refreshData, setRefreshData] = useState(false);

  const loadUsers = async () => {
    const users = await userActions.list();
    await setUsers(users);
  }

  useEffect(() => {
    loadUsers();
  }, [navigate, refreshData]);

  const onItemUpserted = async (newUser: ApiUser, _oldItem?: ApiUser) => {
    await userActions.save(newUser);
    setRefreshData(!refreshData);
  }

  const onItemDeleted = async (user: ApiUser) => {
    if (user.id === emptyUserRepresentation.id) {
      console.info(`Returning on user upserted, this should not happen ${user.id}`);
      return;
    }
    await userActions.remove(user.id);
    setRefreshData(!refreshData);
  }

  const userColumns = useMemo(
    () => [emailColumn, roleColumn, firstNameColumn, lastNameColumn, organizationColumn, commentsColumn, createdByColumn, createdDateColumn],
    [],
  );
  const userTopColumns = useMemo(
    () => [emailColumn, roleColumn, firstNameColumn, lastNameColumn, organizationColumn, commentsColumn],
    [],
  );

  return (
    <Box>
      <CssBaseline />
      <CrudGrid
        processRowUpdate={onItemUpserted}
        onDelete={onItemDeleted}
        rows={users}
        columns={userColumns}
        height='85vh'
        emptyRow={emptyUserRepresentation}
        modelType={"user"}
        topColumns={userTopColumns}
        toolbar={CustomToolbar}
        toolbarProps={{
          showSettings: false,
          hideItemStatusToggles: true
        }}
      />
    </Box>
  );
};

export default withApplicationInsights(UsersPage, "UsersPage");
